// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2TYAV","approved":"Status_approved__1hq9i","rejected":"Status_rejected__1tUss","expired":"Status_expired__10m_g","label":"Status_label__3tywp"};